NtechApp.JobFormContactField = function($view, contactTextFieldId) {
    var me = this;

    this._$view = null;
    this._click = null;

    this._contactTextFieldId = null;

    this._$contactField = null;
    this._$textFormConfirm = null;
    this._selectListVals = null;

    this._construct = function() {
        me._$view = $view;
        me._click = new NtechApp.TouchClickEvent();

        me._contactTextFieldId = contactTextFieldId;

        me._$contactField = me._$view.find("#contactCustomField");
        me._$textFormConfirm = me._$contactField.find("#textPhoneConfirm");

        me._createContactCustomField();
        me._initContactTextField();

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen(me._$contactField, ".selectListItem", function(event) {
            var $option = $(event.target);
            if($option.hasClass("selected"))
                return;

            me._selectContactFieldOption($option);
        });

        me._click.listen(me._$textFormConfirm.find(".confirmBoxWrap"), function(event) {
            var $checkbox = $(event.target).closest(".confirmBoxWrap").find(".icon");
            me._toggleCheckbox($checkbox);
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.JobFormContactField, {
    _createContactCustomField: function() {
        var $input = this._$contactField.find(":hidden");

        var labels = $input.attr("data-selectLabels").split(",");
        var vals = $input.attr("data-selectVals").split(",");
        var selectedVal = $input.attr("data-selectSelected");

        this._selectListVals = vals;

        var $listContent = this._$contactField.find(".selectList .content");
        var wasOptionSelected = false;
        var $lastOption = null;

        for(var i = 0; i < labels.length - 1; i++) {
            var $option = $("<div/>").addClass("selectListItem");
            $option.attr("data-selectListVal", vals[i]);
            $option.text(labels[i]);

            if(vals[i] == selectedVal) {
                wasOptionSelected = true;
                $option.addClass("selected");
            }

            $lastOption = $option;
            $listContent.append($option);
        }

        this._$textFormConfirm.find(".message").text(labels[labels.length - 1]);
        if(!wasOptionSelected) {
            $lastOption.addClass("selected");
            this._$textFormConfirm.css("display", "block");
            this._$textFormConfirm.find(".icon").addClass("selectedBox");
        }
        else {
            if(selectedVal != this._selectListVals[0]) {
                this._$textFormConfirm.css("display", "block");
                this._$textFormConfirm.find(".icon").removeClass("selectedBox");
            }
        }
    },

    _initContactTextField: function() {
        var $textInput = this._$contactField.find(this._contactTextFieldId);

        var selectedVal = this._$contactField.find(":hidden").val();
        if(selectedVal == this._selectListVals[0]) {
            var lastVal = "";
            $textInput.attr("disabled", "disabled");
        }
        else {
            var lastVal = this._$contactField.find(":hidden").attr("data-originalPhone");
            $textInput.removeAttr("disabled");
        }

        $textInput.attr("data-lastVal", lastVal);
    },

    _selectContactFieldOption: function($option) {
        var $textInput = this._$contactField.find(this._contactTextFieldId);

        this._$contactField.find(".selectList .selectListItem").removeClass("selected");
        $option.addClass("selected");

        var selectLastOption = false;
        var val = $option.attr("data-selectListVal");
        if(val == this._selectListVals[0]) {
            this._$textFormConfirm.css("display", "none");
            $textInput.attr("disabled", "disabled");
        }
        else {
            this._$textFormConfirm.css("display", "block");
            $textInput.removeAttr("disabled");

            if(this._$textFormConfirm.find(".icon").hasClass("selectedBox"))
                selectLastOption = true;
        }

        var val = NtechApp.formManager.formatPhoneVal($textInput, "data-lastVal");

        $textInput.attr("data-lastVal", $textInput.val());
        $textInput.val(val);

        var $hiddenInput = this._$contactField.find(":hidden");
        if(!selectLastOption)
            $hiddenInput.val($option.attr("data-selectListVal"));
        else
            $hiddenInput.val(this._selectListVals[this._selectListVals.length - 1]);
    },

    _toggleCheckbox: function($checkbox) {
        var $hiddenInput = this._$contactField.find(":hidden");

        if($checkbox.hasClass("selectedBox")) {
            $checkbox.removeClass("selectedBox");
            $hiddenInput.val(this._selectListVals[this._selectListVals.length - 2]);
        }
        else {
            $checkbox.addClass("selectedBox");
            $hiddenInput.val(this._selectListVals[this._selectListVals.length - 1]);
        }
    }
});